import Vue from "@/shared/node_modules/vue";
import DOMPurify from "dompurify";

// Sanea HTML proveniente de API/CMS/usuario antes de inyectarlo en el DOM.
// Sustituto seguro de `v-html`: elimina <script>, manejadores on*, javascript:, etc.
// evitando XSS almacenado (testimonios, blog, legales, errores, cuerpos de email...).
const sanitize = (value: unknown): string =>
  DOMPurify.sanitize(value == null ? "" : String(value));

Vue.directive("safe-html", {
  bind(el: HTMLElement, binding: any) {
    el.innerHTML = sanitize(binding.value);
  },
  update(el: HTMLElement, binding: any) {
    if (binding.value !== binding.oldValue) {
      el.innerHTML = sanitize(binding.value);
    }
  },
});
